import * as React from 'react';
import { IFacetDTO, ITermDTO } from '../../DTO/search';
import { IContentProps } from '../../models/content-props';

interface IProps {
    facets: IFacetDTO[];
    contentProps: IContentProps;
    selectedTermIds: number[];
    onTermClick: (id: number) => void;
    onResetClick: () => void;
}

export class Facets extends React.Component<IProps, any> {
    renderFacet = (value, index) => {
        return <Facet
            facet={value}
            key={index}
            selectedTermIds={this.props.selectedTermIds}
            onTermClick={this.props.onTermClick} />
    }

    render() {
        if (!this.props.facets) {
            return null;
        }
       

        return (
            <div className="adage-search-filters" data-toggle-container>
                <div className="adage-search-filters-header">
                    <div className="adage-search-filters-header-desktop">
                        <h2>Filters</h2>
                    </div>
                    <button className="adage-search-filters-trigger un-button" data-toggle-trigger>
                        <h2 className="h3-style">Filters</h2>
                       <span className="adage-search-filters-trigger-icon"></span>
                    </button>
                    <button type="button" className="adage-search-filters-clear" onClick={this.props.onResetClick}>{this.props.contentProps.resetButtonText}</button>
                    
                </div>

                {this.props.facets.map(this.renderFacet)}
            </div>
        )
    }
}

interface IFacetProps {
    facet: IFacetDTO;
    selectedTermIds: number[];
    onTermClick: (id: number) => void;
}

interface IFacetState {
    showAll: boolean;
}

export class Facet extends React.Component<IFacetProps, IFacetState> {
    constructor(props) {
        super(props);

        this.state = {
            showAll: false,
        }
    }

    renderTerms = (value, index) => {
        return <Term
            key={index}
            selected={this.props.selectedTermIds.some(id => id === value.id)}
            term={value}
            onTermClick={this.props.onTermClick} />
    }

    render() {
        const { facet } = this.props;
        const { showAll } = this.state;

        if (!facet.terms || facet.terms.length <= 0) {
            return null;
        }

        let splicedTerms = this.displayFilterVisibilityToggle && !showAll && facet.terms.length > facet.maxFiltersToDisplay
            ? facet.terms.slice().splice(0, facet.maxFiltersToDisplay)
            : facet.terms.slice();

        return (
            <div className="adage-search-filters-section" data-toggle-panel>
                <fieldset>
                    <legend><h3 className="visually-hidden"> {facet.displayName}</h3></legend>
                    <ul className="adage-search-filters-list">
                        {splicedTerms.map(this.renderTerms)}
                    </ul>
                    {this.renderShowMore(facet.terms) && <button type="button" className="un-button adage-search-filters-display-toggle show-toggle" onClick={() => this.setShowAll(true)}>{facet.viewMoreFiltersMessage || 'Show More'}</button>}
                    {this.renderShowLess(facet.terms) && <button type="button" className="un-button adage-search-filters-display-toggle hide-toggle" onClick={() => this.setShowAll(false)}>{facet.hideMoreFiltersMessage || 'Show Less'}</button>}
                </fieldset>
            </div>
        )
    }

    renderShowMore = (terms: ITermDTO[]) => {
        return this.displayFilterVisibilityToggle && terms.length > this.props.facet.maxFiltersToDisplay && !this.state.showAll;
    }

    renderShowLess = (terms: ITermDTO[]) => {
        return this.displayFilterVisibilityToggle && terms.length > this.props.facet.maxFiltersToDisplay && this.state.showAll;
    }

    get displayFilterVisibilityToggle() {
        return this.props.facet.maxFiltersToDisplay > 0;
    }

    setShowAll = (value: boolean) => {
        this.setState({ showAll: value });
    }
}

interface ITermProps {
    term: ITermDTO;
    selected: boolean;
    onTermClick: (id: number) => void;
}

export class Term extends React.Component<ITermProps, any> {
    render() {
        const { term, onTermClick, selected } = this.props;

        return (
            <li className="adage-search-filters-list-item">
                <input type="checkbox"
                    onChange={() => onTermClick(term.id)}
                    id={term.term}
                    name={term.term}
                    checked={selected}
                    value={term.term} />
                <label className="bold" htmlFor={term.term}>{term.displayName}</label>
                <span className="adage-search-filters-list-item-number">({term.hits})</span>
            </li>
        )
    }
}